import EmailVerification from "../../components/auth/EmailVerification";
import AuthPageLayout from "./AuthPageLayout";

export default function EmailVerificationPage() {
  return (
    <AuthPageLayout>
      <EmailVerification />
    </AuthPageLayout>
  );
}